export default "__VITE_ASSET__CH6LsHRV__"